<template lang="pug">
    //v-card.pa-5
        v-layout( row wrap )
            v-flex( xs12 )
                v-toolbar( color="primary" dark flat )
                    v-toolbar-title Ingrese período para descargar libro diario
                    v-spacer
    r-form(
        ref="refCFDailyLedger"
        reset-text='reiniciar'
        submit-text='generar'
        title='Generar libro diario'
        v-bind='formProps'
        @submit='submitDownloadDailyLedgerExcel'
    )
                //v-btn.ma-4( color="success" large @click="submitDownloadDailyLedgerExcel") Descargar Excel
</template>

<script>
    // 
    import { mapActions, mapState } from 'vuex'
    import { RForm } from '@/components/reusable_components/next'
    //
    import AccDailyLedgerModel from '@/models/Accounting/AccDailyLedger'
    import AccDailyLedgerFields from '@/views/Accounting/AccDailyLedger/AccDailyLedgerFields'
    //
    import { generateDailyLedgerExcel } from '@/services/api/dailyLedger'
    //
    export default {
        name: 'daily-ledger-download',
        components: {
            RForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * 
             */
            formProps() {
                return {
                    fields: AccDailyLedgerFields,
                }
            },
        },
        data() {
            return {
                fields: FieldsDailyLedger,
            }
        },
        methods: {

            /**
             *
             */
            ...mapActions('MenuesModule', ['setTitleTopBar']),

            /**
             *            
             */
            ...mapActions('SnackbarModalModule', {
                initSnackbar: 'initSnackbar',
                hideSnack: 'hideSnack',
                resetSnackbarState: 'resetSnackbarState',
                setMessageConfirmSnack: 'setMessageConfirmSnack',
            }),

            /**
             * 
             */            
            submitDownloadDailyLedgerExcel: function() {
                let vmodels = this.$refs.refCFDailyLedger.value
                if (vmodels.init_date !== '' && vmodels.end_date !== '') {
                    if (vmodels.init_date > vmodels.end_date) {
                        this.showSnackbar(
                            'error',
                            'Error',
                            'La fecha de inicio no puede ser mayor a la fecha de termino'
                        )
                    } else {
                        this.resetSnackbarState()
                        this.setMessageConfirmSnack('Descargar')
                        let payload = this.fillSnack(
                            'info',
                            '¿Desea descargar libro diario?',
                            ''
                        )
                        this.initSnackbar(payload)
                    }
                } else {
                    this.showSnackbar(
                        'warning',
                        'Acción inválida',
                        'Complete los campos'
                    )
                }
            },
            
            resetForm: function() {
                this.$refs.refCFDailyLedger.vmodels = []
            },
            
            showSnackbar: function(type, title, message) {
                this.initSnackbar(this.fillSnack(type, title, message))
            },
        },
        watch: {
            // this.$refs.refTaxableForm.vmodels
            async responseConfirm(val) {
                //-
                if (val === 'Descargar') {
                    this.resetSnackbarState()
                    let initDate = this.$refs.refCFDailyLedger.value.init_date
                    let endDate = this.$refs.refCFDailyLedger.value.end_date
                    let branchOffice = this.$refs.refCFDailyLedger.value.g_branch_office_id
                    // let accounts =
                    // if(accounts) let response = await generatePrevisionIndicator(initDate, endDate, accounts)
                    let response = await generateDailyLedgerExcel(initDate, endDate, branchOffice)
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    )
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                        'download',
                        `Libro-Mayor-${initDate}_${endDate}.xlsx`
                    )
                    document.body.appendChild(link)
                    link.click()
                    //-
                    if (response.status == 200) {
                        let payload = this.fillSnack(
                            'success',
                            'Descarga correcta',
                            ''
                        )
                        this.initSnackbar(payload)
                        this.resetForm()
                    } else {
                        let payload = this.fillSnack(
                            'error',
                            'Error',
                            response.error
                        )
                        this.initSnackbar(payload)
                    }
                }
            },
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('EXECUTE_EXPORT_ACCOUNTING_DAILY_LEDGER'))
                    ctx.$router.push('/')
            })
        },
        mounted() {
            this.setTitleTopBar('Libro diario')
        },
    }
</script>